// extracted by mini-css-extract-plugin
export var breadcrumbs = "g_7";
export var list = "g_B";
export var listItem = "g_C";
export var crumb_content = "g_8";
export var crumb = "g_9";